<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
            <el-tab-pane label="学习成长集合" name="0">
                榜单:<cooperateBank :sectionClassId="2"></cooperateBank>
                对我点赞:<cooperateLike :sectionClassId="2"></cooperateLike>
                对我评论:<cooperateDiscuss :sectionClassId="2"></cooperateDiscuss>
                需要我帮助:<cooperateCall :sectionClassId="2"></cooperateCall>
                回复我:<cooperateCallback :sectionClassId="2"></cooperateCallback>
            </el-tab-pane>
            <el-tab-pane label="学习成长" name="1">
                <cooperateForm :sectionClassId="2"></cooperateForm>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import cooperateForm from '@/components/cooperative/cooperativeForm'
    import cooperateBank from '@/components/cooperative/cooperativeBank'
    import cooperateCall from '@/components/cooperative/cooperativeCall'
    import cooperateCallback from '@/components/cooperative/cooperativeCallback'
    import cooperateLike from '@/components/cooperative/cooperativeLike'
    import cooperateDiscuss from '@/components/cooperative/cooperativeDiscuss'

    //定义组件
    export default {
        data() {
            return {
                activeName:'0',
                activeName1:'0',
            }
        },
        components:{
            cooperateForm,
            cooperateBank,
            cooperateCall,
            cooperateCallback,
            cooperateLike,
            cooperateDiscuss,

        },
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/growth.vue